import { CHANGE_MAP_LAYERS_LIST_VISIBILITY } from './types';

export const changeMapLayersListVisibility = (status: boolean) => ({
    type: CHANGE_MAP_LAYERS_LIST_VISIBILITY,
    payload: status,
});
